import { render } from "./StaticInfo.vue?vue&type=template&id=3fd754f0&scoped=true"
import script from "./StaticInfo.vue?vue&type=script&lang=js"
export * from "./StaticInfo.vue?vue&type=script&lang=js"

import "./StaticInfo.vue?vue&type=style&index=0&id=3fd754f0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd754f0"]])

export default __exports__